import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { isEmpty } from 'lodash/fp';

import Box from 'components/box';
import Spinner from 'components/spinner';
import { Text } from 'components/text';
import Icon from 'components/icon';
import { title } from 'lib/config';

/**
 * Component
 */

const LoadingIndicator = ({ noun, error, title = null, ...props }) => (
  <Box flex justifyContent="center" alignItems="center" {...props}>
    {isEmpty(error) ? (
      <Fragment>
        <Box paddingRight={4} color="gray.5">
          <Spinner small />
        </Box>
        <Text verticalAlign="middle">
          {!title ? `Loading ${noun}...` : title}
        </Text>
      </Fragment>
    ) : (
      <Fragment>
        <Box paddingRight={4} color="yellow.7">
          <Icon name="warning" />
        </Box>
        <Text verticalAlign="middle">
          {`Error loading ${noun} : ${error}`}
        </Text>
      </Fragment>
    )}
  </Box>
);

LoadingIndicator.propTypes = {
  error: PropTypes.string,
  title: PropTypes.string,
  noun: PropTypes.string.isRequired,
};

LoadingIndicator.defaultProps = {
  error: null,
  title: null,
};

/**
 * Exports
 */

export default LoadingIndicator;
